var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIconGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81361 8.79927C4.5651 9.06647 4.16217 9.06647 3.91366 8.79927L0.51972 5.15015C0.271205 4.88295 0.271205 4.44973 0.51972 4.18253L3.91366 0.533408C4.16217 0.266208 4.5651 0.266208 4.81361 0.533408C5.06213 0.800609 5.06213 1.23383 4.81361 1.50103L1.86965 4.66634L4.81361 7.83165C5.06213 8.09886 5.06213 8.53207 4.81361 8.79927Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconGray);
export default __webpack_public_path__ + "static/media/BackIconGray.ef25eeba190b32b843587834730f0b9d.svg";
export { ForwardRef as ReactComponent };